import * as React from "react";

export const OneDrive = () => (
    <>
        <mask id="mask0_5562_6063" maskUnits="userSpaceOnUse" x="1" y="3" width="14" height="10">
            <path
                d="M4.42553 12.375C2.53365 12.375 1 10.8733 1 9.02082C1 7.20904 2.46703 5.73283 4.30143 5.66883C5.05797 4.44385 6.4313 3.625 8 3.625C10.026 3.625 11.7261 4.9908 12.1925 6.83341C13.7451 6.84513 15 8.08116 15 9.60418C15 11.0856 13.6875 12.375 12.3191 12.3712L4.42553 12.375Z"
                fill="#C4C4C4"
            />
        </mask>
        <g mask="url(#mask0_5562_6063)">
            <path
                d="M4.4257 12.3756C3.35298 12.3756 2.39544 11.8928 1.76733 11.1371L8.89377 8.14648L14.4351 11.2664C13.9468 11.9036 13.2091 12.3756 12.3752 12.3719C11.1174 12.3756 6.27752 12.3756 4.4257 12.3756Z"
                fill="url(#paint0_linear_5562_6063)"
            />
            <path
                d="M12.1906 6.82617L8.8938 8.14677L14.4352 11.2667C14.7899 10.8037 15.0002 10.2285 15.0002 9.60517C15.0002 8.08215 13.7453 6.84612 12.1927 6.8344C12.192 6.83164 12.1913 6.82893 12.1906 6.82617Z"
                fill="url(#paint1_linear_5562_6063)"
            />
            <path
                d="M4.0907 5.68247L8.89351 8.14582L12.1903 6.82523C11.721 4.98677 10.0229 3.625 7.99987 3.625C6.43117 3.625 5.05785 4.44385 4.30132 5.66883C4.23055 5.67132 4.16032 5.67587 4.0907 5.68247Z"
                fill="url(#paint2_linear_5562_6063)"
            />
            <path
                d="M1.76716 11.1356L8.89359 8.14498L4.09081 5.68164C2.35602 5.8464 1 7.27812 1 9.01998C1 9.8221 1.28752 10.5584 1.76716 11.1356Z"
                fill="url(#paint3_linear_5562_6063)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_5562_6063"
                x1="2.93633"
                y1="11.7923"
                x2="12.9135"
                y2="11.184"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2086B8" />
                <stop offset="1" stopColor="#46D3F6" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5562_6063"
                x1="11.4257"
                y1="9.60513"
                x2="14.2172"
                y2="7.65449"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#1694DB" />
                <stop offset="1" stopColor="#62C3FE" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5562_6063"
                x1="4.72329"
                y1="4.20833"
                x2="11.2084"
                y2="7.97147"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0D3D78" />
                <stop offset="1" stopColor="#063B83" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_5562_6063"
                x1="0.851062"
                y1="9.74917"
                x2="7.37149"
                y2="7.32765"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#16589B" />
                <stop offset="1" stopColor="#1464B7" />
            </linearGradient>
        </defs>
    </>
);
